import type { USER_PERMISSION_LEVELS } from "common/constants";
import type { UserPermissions, UserPermissionsKey } from "common/types";

export default function useMemberPermissionsState(
  permissions: UserPermissions,
) {
  const memberPermissionsState: Record<
    UserPermissionsKey,
    keyof typeof USER_PERMISSION_LEVELS
  > = {
    members: "none",
    public_api: "none",
    accounts: "none",
    billing: "none",
    campaigns: "none",
    inbox: "none",
    integrations: "none",
    leads: "none",
    templates: "none",
    webhooks: "none",
  };
  permissions.forEach((permission) => {
    const splitPermissions = permission.split("_");
    const key = splitPermissions
      .slice(0, splitPermissions.length - 1)
      .join("_");
    const level = splitPermissions[splitPermissions.length - 1];

    if (level === "full") {
      memberPermissionsState[key as UserPermissionsKey] = "full";
    } else if (
      level === "limited" &&
      memberPermissionsState[key as UserPermissionsKey] !== "full"
    ) {
      memberPermissionsState[key as UserPermissionsKey] = "limited";
    }
  });

  return { memberPermissionsState };
}
